import Vue from 'vue'

const breadcrumb = {
  state: {
    list: [],
    list2: []
  },

  mutations: {
    SET_BREADCRUMB_LIST(state, data) {
      state.list = data
      Vue.ls.set('breadcrumb', data)
    },
    SET_BREADCRUMB_LIST2(state, data) {
      state.list2 = data
      Vue.ls.set('breadcrumb2', data)
    }
  },

  actions: {
    setBreadcrumbList({ commit },data) {
      let breadcrumb = Vue.ls.get('breadcrumb') || []
      let new_breadcrumb = breadcrumb.filter(item => item.index < data.index) || []
      new_breadcrumb.push({
        name:data.name,
        index:data.index,
        router_name:data.router_name,
        query:data.query
      })
      commit('SET_BREADCRUMB_LIST', new_breadcrumb)
    },

    getBreadcrumbList({ commit }) {
      let breadcrumb = Vue.ls.get('breadcrumb') || []
      commit('SET_BREADCRUMB_LIST', breadcrumb)
    },

    setBreadcrumbList2({ commit },data) {
      let breadcrumb = Vue.ls.get('breadcrumb2') || []
      let typeid = ''
      if(data.type == 'cate') {
        typeid = 'catalogid'
      } else if (data.type == 'exam') {
        typeid = 'lessionid'
      }
      //如果是跟路径，则重置
      if(data[typeid] == 0) {
        breadcrumb = [
          {
            name:data.name,
            router_name:data.router_name,
            query:data.query,
            [typeid]:data[typeid],
            type:data.type
          }
        ]
        commit('SET_BREADCRUMB_LIST2', breadcrumb)
        return false
      }

      let i = breadcrumb.findIndex(item => item[typeid] == data[typeid])
      if(i > -1) {
        breadcrumb = breadcrumb.slice(0, i+1)
      } else {
        breadcrumb.push({
          name:data.name,
          router_name:data.router_name,
          query:data.query,
          [typeid]:data[typeid],
          type:data.type
        })
      }
      commit('SET_BREADCRUMB_LIST2', breadcrumb)
    },

    getBreadcrumbList2({ commit }) {
      let breadcrumb = Vue.ls.get('breadcrumb2') || []
      commit('SET_BREADCRUMB_LIST2', breadcrumb)
    }
  }

};

export default breadcrumb


// WEBPACK FOOTER //
// ./src/store/modules/breadcrumb.js